import { render } from "./EditorialF.vue?vue&type=template&id=5a5ec032&scoped=true"
import script from "./EditorialF.vue?vue&type=script&lang=js"
export * from "./EditorialF.vue?vue&type=script&lang=js"

import "./EditorialF.vue?vue&type=style&index=0&id=5a5ec032&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a5ec032"]])

export default __exports__